import { API_BASE, ODATA_BASE, MEDIA_BASE } from "helpers/api_config";
import { gorselYuklemeParametreleri } from "helpers/gorselKucult";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";
import { truncate, resolveJobAdImage } from "helpers/contentUtils";
import * as moment from "moment";


//Import Breadcrumb
import Dropzone from 'react-dropzone-uploader';
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";


import {
  getJob_Advertisement as onGetJob_Advertisement,
  updateJob_Advertisement as onUpdateJob_Advertisement,
  deleteJob_Advertisement as onDeleteJob_Advertisement,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

import SayfaRehberi from "../../../components/Common/SayfaRehberi";
const ContactsList = props => {

  //meta title
  document.title = "İLANLAR | BERLİN ESNAF ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState('');

    const [getIsActive, setIsActive] = useState(false);
  
  const [getHtmlDataLong, setHtmlDataLong] = useState();
   
  const [getHtmlDataLongSecond, setHtmlDataLongSecond] = useState();
  const [getFileSubMedia, setFileSubMedia] = useState([]);

  const [getSubMediaID, setSubMediaID] = useState();

  const [getFileSubMediaAdd, setFileSubMediaAdd] = useState([]);

  // Duzenlenen ilanin gorselleri (Job_Advertisement_Image tablosu).
  // Panelde ilana fotograf ekleme/silme HIC YOKTU; sadece "Aktif mi?" anahtari vardi.
  const [getAdvertImages, setAdvertImages] = useState([]);
  const [getImageBusy, setImageBusy] = useState(false);

  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {

   
 

    },
    validationSchema: Yup.object({


    }),
    onSubmit: () => {
      // İlanlar mobil uygulamadan oluşturuluyor; panelden sadece düzenleme yapılır.
      if (!isEdit || !contactEdit) {
        toggle();
        return;
      }

      const updateUser = {
        ID: contactEdit.ID,
        Job_Advertisement_Active: getIsActive,
      };
      dispatch(onUpdateJob_Advertisement(updateUser));
      setIsEdit(false);
      validation.resetForm();
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.jobadvertisement,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);

  const [isEdit, setIsEdit] = useState(false);





  const [getCategory, setCategory] = useState([]);


  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "İlan Başlık",
        accessor: "Job_Advertisement_Title",
        filterable: true,
        // Başlıklar mobilden HTML olarak geliyor, tabloda düz metne çevriliyor
        Cell: cellProps => truncate(cellProps.value, 60),
      },

      {
        Header: "İlan Açıklama",
        accessor: "Job_Advertisement_Desc",
        filterable: true,
        Cell: cellProps => truncate(cellProps.value, 90),
      },

      {
        Header: "Görsel",
        accessor: "Job_Advertisement_Image",
        disableFilters: true,
        Cell: cellProps => {
          const images = cellProps.value || [];
          if (!images.length) return <span className="text-muted">—</span>;
          return (
            <div className="d-flex align-items-center gap-1">
              <img
                className="rounded avatar-sm"
                style={{ objectFit: "cover" }}
                src={resolveJobAdImage(images[0].Job_Advertisement_Image_Text)}
                alt=""
              />
              {images.length > 1 && (
                <span className="badge badge-soft-primary">+{images.length - 1}</span>
              )}
            </div>
          );
        },
      },

      {
        Header: "Kategori",
        accessor: "Job_Advertisement_SubCategory.Job_Advertisement_SubCategory_Text",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Kullanıcı Adı",
        accessor: "Users.Users_Name_Surname",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

   
      {
        Header: "Aktif Mi?",
        accessor: "Job_Advertisement_Active",
        filterable: true,
        Cell: cellProps => {
          return <Status {...cellProps} />;
        },
      },

      {
        Header: "İşlemler",
        Cell: cellProps => {
          // Tooltip id'leri satır bazında benzersiz olmalı, yoksa hepsi ilk satıra bağlanır
          const rowId = cellProps.row.original.ID;
          return (
            <div className="d-flex gap-3">

              <Link
                to="#"
                className="text-primary"
                onClick={() => {
                  handlePreviewClick(cellProps.row.original);
                }}
              >
                <i className="mdi mdi-eye-outline font-size-18" id={`previewtooltip-${rowId}`} />
                <UncontrolledTooltip placement="top" target={`previewtooltip-${rowId}`}>
                  Önizle
                </UncontrolledTooltip>
              </Link>

              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id={`edittooltip-${rowId}`} />
                <UncontrolledTooltip placement="top" target={`edittooltip-${rowId}`}>
                  Düzenle
                </UncontrolledTooltip>
              </Link>

              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id={`deletetooltip-${rowId}`} />
                <UncontrolledTooltip placement="top" target={`deletetooltip-${rowId}`}>
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  // NOT: burada başka bir projeden (Luxun/MSE/Kupon) kalma `_getAuthData`
  // vardı; ölü :9093 portuna istek atıyor, sonucu (`getCategory`) hiçbir yerde
  // gösterilmiyordu. Her sayfa açılışında yakalanmamış hata üretiyordu — kaldırıldı.

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetJob_Advertisement());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  const toggle = () => {
    // Modal kapanirken listeyi tazele: gorsel ekleme/silme dogrudan OData'ya
    // gidiyor, redux'taki liste aksi halde eski gorselleri gostermeye devam eder.
    if (modal) dispatch(onGetJob_Advertisement());
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };

  const togglePreview = () => {
    setPreviewModal(!previewModal);
  };

  const handlePreviewClick = arg => {
    setPreviewItem(arg);
    setPreviewModal(true);
  };


  const handleUserClickMedia = (arg) => {
    const user = arg;

    setSubMediaID(user.ID)

    setFileSubMedia(user.EducationSubItem_Media)

    toggleMedia();
  };


  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);

    setAdvertImages(user.Job_Advertisement_Image || [])

    setIsActive(user.Job_Advertisement_Active)

    setIsEdit(true);


    toggle();
  };


  

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };
  // NOT: burada `setContact(<liste>)` çağıran iki useEffect vardı.
  // `contact` SEÇİLİ SATIRI tutuyor; liste her değiştiğinde tüm dizi ile
  // eziliyor, dizide `.ID` olmadığı için silme sessizce hiçbir şey yapmıyordu.

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteJob_Advertisement(contact.ID));
    }
    setContact(undefined);
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  // --- ILAN GORSELLERI -------------------------------------------------
  // Panelden yuklenen dosyalar MEDIA_BASE'e (megasubdomain) dusuyor; mobilden
  // yuklenenler ise berlinesnafapi/Uploads altinda duruyor. Iki sunucuyu
  // karistirmamak icin panelden eklenen gorselin TAM ADRESI kaydediliyor;
  // hem panel (resolveJobAdImage) hem uygulama (jobAdvImageUri) "http" ile
  // baslayan degeri oldugu gibi kullaniyor.
  // Gorseller yuklenmeden once kucultulur (bkz. helpers/gorselKucult.js)
  const getUploadParams = gorselYuklemeParametreleri

  const handleAdvertImageUpload = ({ xhr }) => {
    if (!xhr) return;
    xhr.onreadystatechange = async () => {
      if (xhr.readyState !== 4) return;
      if (!contactEdit || !contactEdit.ID) return;
      try {
        const result = JSON.parse(xhr.response);
        const fileName = result && result.file && result.file.filename;
        if (!fileName) return;
        setImageBusy(true);
        const res = await axios.post(`${ODATA_BASE}/Job_Advertisement_Image`, {
          Job_Advertisement_Image_Text: `${MEDIA_BASE}/${fileName}`,
          Job_Advertisement_ID: contactEdit.ID,
        });
        const created = res.data && res.data.value && res.data.value[0];
        if (created) setAdvertImages(old => [...old, created]);
      } catch (err) {
        console.error("İlan görseli eklenemedi", err);
      } finally {
        setImageBusy(false);
      }
    }
  }

  /**
   * Gorseli ilandan cikarir.
   *
   * NOT: API'de Job_Advertisement_Image icin CALISAN bir silme ucu yok
   * (DELETE 404 doner, metadata'daki DeleteJob_Advertisement_Image fonksiyonu
   * da yonlendirilmemis). Bu yuzden kayit siliynmiyor, ilandan KOPARILIYOR
   * (Job_Advertisement_ID = null). Uygulama gorselleri ilan uzerinden
   * cektigi icin kopan kayit hicbir yerde gorunmuyor.
   */
  const handleAdvertImageDelete = async (image) => {
    try {
      setImageBusy(true);
      await axios.patch(`${ODATA_BASE}/Job_Advertisement_Image(${image.ID})`, {
        Job_Advertisement_ID: null,
      });
      setAdvertImages(old => old.filter(x => x.ID !== image.ID));
    } catch (err) {
      console.error("İlan görseli kaldırılamadı", err);
    } finally {
      setImageBusy(false);
    }
  }

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }


  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="İlanlar  Listesi" />
          <SayfaRehberi sayfa="jobadvertisement" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddAktuelCat={false}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

            
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "İlan Düzenle" : "İlan"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>

                            {/* ILAN GORSELLERI: panelde hic yoktu, sadece
                                "Aktif mi?" anahtari vardi. */}
                            {isEdit && contactEdit ? (
                              <div className="mb-3">
                                <Label className="form-label">İlan Görselleri</Label>

                                {getAdvertImages.length > 0 ? (
                                  <div className="d-flex flex-wrap gap-2 mb-2">
                                    {getAdvertImages.map(img => (
                                      <div key={img.ID} className="text-center">
                                        <img
                                          className="rounded avatar-lg"
                                          style={{ objectFit: "cover" }}
                                          src={resolveJobAdImage(img.Job_Advertisement_Image_Text)}
                                          alt=""
                                        />
                                        <button
                                          type="button"
                                          disabled={getImageBusy}
                                          onClick={() => handleAdvertImageDelete(img)}
                                          className="btn btn-sm btn-danger d-block w-100 mt-1"
                                        >
                                          Kaldır
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <p className="text-muted font-size-12 mb-2">
                                    Bu ilanda görsel yok.
                                  </p>
                                )}

                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleAdvertImageUpload}
                                  multiple={true}
                                  maxFiles={10}
                                  styles={{
                                    dropzone: { overflow: 'auto', minHeight: 90, border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}
                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*"
                                />
                                <small className="text-muted">
                                  Yüklenen görsel anında ilana eklenir, ayrıca Kaydet'e basmanıza gerek yoktur.
                                </small>
                              </div>
                            ) : null}

                            <div className="d-flex">
                              <label className="mb-0" htmlFor="sw-1">Aktif Mi?</label>

                              <div className="square-switch">

                                <input
                                  type="checkbox"
                                  id="sw-1"
                                  className="switch"
                                  checked={!!(getIsActive)}
                                  onChange={() =>
                                    setIsActive(!getIsActive)
                                  }
                                />
                                <label
                                  htmlFor="sw-1"
                                  data-on-label="Aktif "
                                  data-off-label="Pasif"
                                />
                              </div>

                            </div>

                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>

                  {/* İlan önizleme: açıklama HTML olarak geldiği için burada render ediliyor */}
                  <Modal isOpen={previewModal} toggle={togglePreview} size="lg" scrollable>
                    <ModalHeader toggle={togglePreview} tag="h4">
                      İlan Önizleme
                    </ModalHeader>
                    <ModalBody>
                      {previewItem && (
                        <div>
                          <h5
                            className="mb-1"
                            dangerouslySetInnerHTML={{
                              __html: previewItem.Job_Advertisement_Title || "<em>Başlık yok</em>",
                            }}
                          />
                          <div className="text-muted mb-3">
                            {previewItem.Job_Advertisement_SubCategory
                              ? previewItem.Job_Advertisement_SubCategory
                                  .Job_Advertisement_SubCategory_Text
                              : "Kategori yok"}
                            {" · "}
                            {previewItem.Job_Advertisement_DateTime
                              ? moment(previewItem.Job_Advertisement_DateTime).format(
                                  "DD.MM.YYYY HH:mm"
                                )
                              : "Tarih yok"}
                            {" · "}
                            <span
                              className={
                                "badge badge-soft-" +
                                (previewItem.Job_Advertisement_Active ? "success" : "danger")
                              }
                            >
                              {previewItem.Job_Advertisement_Active ? "Aktif" : "Pasif"}
                            </span>
                          </div>

                          {(previewItem.Job_Advertisement_Image || []).length > 0 && (
                            <div className="d-flex flex-wrap gap-2 mb-3">
                              {previewItem.Job_Advertisement_Image.map(img => (
                                <a
                                  key={img.ID}
                                  href={resolveJobAdImage(img.Job_Advertisement_Image_Text)}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img
                                    src={resolveJobAdImage(img.Job_Advertisement_Image_Text)}
                                    alt=""
                                    style={{
                                      width: 140,
                                      height: 140,
                                      objectFit: "cover",
                                      borderRadius: 6,
                                    }}
                                  />
                                </a>
                              ))}
                            </div>
                          )}

                          <Label className="form-label">Açıklama</Label>
                          <div
                            className="border rounded p-3 mb-3"
                            style={{ background: "#fff" }}
                            dangerouslySetInnerHTML={{
                              __html:
                                previewItem.Job_Advertisement_Desc ||
                                "<em class='text-muted'>Açıklama girilmemiş</em>",
                            }}
                          />

                          <Row>
                            <Col md={6} className="mb-2">
                              <Label className="form-label mb-0">İlan Sahibi</Label>
                              <div>
                                {previewItem.Users
                                  ? previewItem.Users.Users_Name_Surname
                                  : "—"}
                              </div>
                            </Col>
                            <Col md={6} className="mb-2">
                              <Label className="form-label mb-0">Telefon</Label>
                              <div>{previewItem.Job_Advertisement_Number || "—"}</div>
                            </Col>
                            <Col md={6} className="mb-2">
                              <Label className="form-label mb-0">Adres</Label>
                              <div>{previewItem.Job_Advertisement_Address || "—"}</div>
                            </Col>
                            <Col md={6} className="mb-2">
                              <Label className="form-label mb-0">Görüntülenme / Beğeni</Label>
                              <div>
                                {previewItem.Job_Advertisement_Seen || 0} /{" "}
                                {previewItem.Job_Advertisement_Liked || 0}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
